
import React, { useState, useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EventFormValues } from '../schemas/eventFormSchema';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CalendarIcon } from "lucide-react";
import DateTimeSelector from './date-time/DateTimeSelector';
import DateTimeFieldsWatcher from './date-time/DateTimeFieldsWatcher';

interface DateTimeFieldsProps {
  form: UseFormReturn<EventFormValues>;
}

const DateTimeFields = ({ form }: DateTimeFieldsProps) => {
  const [isMultiDay, setIsMultiDay] = useState(false);
  const [hasTime, setHasTime] = useState(false);
  
  // Állapot inicializálása formadatok alapján
  useEffect(() => {
    // Ellenőrizzük, hogy többnapos-e
    const startDate = form.getValues("startDate");
    const endDate = form.getValues("endDate");
    const isSameDay = startDate.toDateString() === endDate.toDateString();
    setIsMultiDay(!isSameDay);
    
    // Ellenőrizzük, hogy van-e megadva időpont
    const timeNotSpecified = form.getValues("timeNotSpecified");
    setHasTime(!timeNotSpecified);
  }, [form]);
  
  // Időpont megadás/törlés kezelése
  const handleHasTimeChange = (newHasTime: boolean) => {
    setHasTime(newHasTime);
    form.setValue("timeNotSpecified", !newHasTime, { shouldDirty: true });
  };
  
  // Többnapos esemény beállítás
  const handleMultiDayChange = (newIsMultiDay: boolean) => {
    setIsMultiDay(newIsMultiDay);
    
    // Ha egynapos lett, állítsuk be a végdátumot a kezdődátumra
    if (!newIsMultiDay) {
      const startDate = form.getValues("startDate");
      form.setValue("endDate", startDate, { shouldDirty: true });
    }
  };
  
  return (
    <Card className="border-2 border-medihub-primary/20">
      <CardHeader className="bg-medihub-primary/10 pb-2">
        <CardTitle className="text-lg flex items-center gap-2 text-medihub-primary">
          <CalendarIcon className="h-5 w-5" />
          Időpontok
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        {/* Láthatatlan komponens ami figyeli a form változásait */}
        <DateTimeFieldsWatcher form={form} />
        
        <DateTimeSelector
          form={form}
          startDateName="startDate"
          endDateName="endDate"
          startTimeName="startTime"
          endTimeName="endTime"
          isMultiDay={isMultiDay}
          onMultiDayChange={handleMultiDayChange}
          hasTime={hasTime}
          onHasTimeChange={handleHasTimeChange}
        />
      </CardContent>
    </Card>
  );
};

export default DateTimeFields;
